// src/components/ui/Button.jsx
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import '../../styles/components/ui/Button.css';

export default function Button({
  as = 'button',       // 'button' | 'link' | a component
  to,
  type = 'button',
  variant = 'primary', // primary | secondary | ghost | danger
  size = 'md',         // sm | md | lg
  className = '',
  children,
  ...rest
}) {
  const cls = `btn btn--${variant} btn--${size} ${className}`.trim();

  // Normalize the "as" prop:
  // - 'link' (string)  => RouterLink
  // - RouterLink (component) => RouterLink
  // - 'button' or anything falsy => native <button>
  let Comp;
  if (as === 'link' || as === RouterLink) {
    Comp = RouterLink;
  } else if (!as || as === 'button') {
    Comp = 'button';
  } else {
    // allow custom components too
    Comp = as;
  }

  if (Comp === RouterLink) {
    return (
      <RouterLink to={to} className={cls} {...rest}>
        {children}
      </RouterLink>
    );
  }

  if (Comp === 'button') {
    return (
      <button type={type} className={cls} {...rest}>
        {children}
      </button>
    );
  }

  // Custom component case
  return (
    <Comp to={to} className={cls} {...rest}>
      {children}
    </Comp>
  );
}